import SiafLiteApiRepository from "../../external/siafLiteApi";

class AnpService {
  constructor() {
    this.urlBase = "/fiscal/anp";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAllAvancado(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).patch(body);
  }
}

export default AnpService;
